<template>
    <v-dialog width="580" v-model="show">
        <v-card>
            <v-card-title
                    class="dialog-header-text ">
                Requires Consultation
                <v-spacer></v-spacer>
                <v-icon large color="#46C3B2" @click.stop="closeDialog">
                    mdi-close
                </v-icon>
            </v-card-title>

            <v-card-text class="mt-0 ">
                <v-divider></v-divider>
                <v-row class="pa-5 ">
                    <v-col class="col-12 pl-0 ml-n2 dialog-body-text">
                        Based on the information provided, one of our advisors will reach out to you to ensure you get the best rate available.

                        <v-btn class="input-control-text mt-md-8 mt-sm-6 mt-xs-6 ctn-btn btn-no-transform"
                               type="button" @click="requestConsultation" large dark block depressed color="#005851">
                            Continue
                        </v-btn>
                        <v-progress-linear class="mt-6" v-if="redirecting"
                                           indeterminate
                                           color="#46C3B2"
                        >
                        </v-progress-linear>

                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import quilityMixin from "@/mixins/quilityMixin";

export default {
    name: "SubscriptionDialog",
    mixins: [quilityMixin],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        zohoId: {
            type: String,
            default: null
        },
    },
    data:() => ({
        redirecting: false,
    }),
    computed: {
        show: {
            get() {
                return this.$attrs.value
            },
            set(value) {
                if(!value) {
                    this.$emit('input', value);
                }
            }
        },
    },
    methods:{
        async requestConsultation() {
            window.location.href = process.env.VUE_APP_TERM_CONSULT_URL
        },
        async closeDialog() {
            window.location.href = process.env.VUE_APP_TERM_CONSULT_URL
        }
    }
}
</script>

<style scoped>
    .dialog-body-text {
        font-size: 1rem;
        font-family: "Montserrat", sans-serif;
        font-weight: 300;
        color: black;
    }

    .btn-no-transform {
        text-transform: none;
    }

    .card-title {
        font-weight: bold;
        font-size: 2rem;
        font-family: "Montserrat", sans-serif;
        color:black;
    }

    @media only screen and (max-width: 768px) {
        .card-title {
            font-size: 1rem;
        }

        .ctn-btn {
            margin-top: 6%;
        }
    }
</style>
